// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 신규 가이드 페이지용 스타일시트 */
.new-guide-page {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.new-guide-content {
  padding: 20px;
}
.new-guide-content h2 {
  margin-bottom: 24px;
  color: #1D283C;
}
.new-guide-content p {
  margin-bottom: 32px;
  color: #666;
  line-height: 1.6;
}

.new-stats-container {
  display: flex;
  gap: 20px;
  margin-top: 30px;
}

.new-stat-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex: 1 1;
}
.new-stat-card h3 {
  font-size: 16px;
  color: #666;
  margin-bottom: 12px;
}
.new-stat-card .new-stat-value {
  font-size: 24px;
  font-weight: 600;
  color: #1D283C;
}

/* 페이지 제목 스타일은 공통적으로 사용되는 것 같으므로 그대로 사용 */`, "",{"version":3,"sources":["webpack://./src/pages/Guide/NewGuideStyled.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,sBAAA;AACA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;AAEF;AAAE;EACE,mBAAA;EACA,cAAA;AAEJ;AACE;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;AACJ;;AAGA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,SAAA;AAAF;AAEE;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAAJ;AAGE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADJ;;AAKA,yCAAA","sourcesContent":["/* 신규 가이드 페이지용 스타일시트 */\n.new-guide-page {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n.new-guide-content {\n  padding: 20px;\n  \n  h2 {\n    margin-bottom: 24px;\n    color: #1D283C;\n  }\n  \n  p {\n    margin-bottom: 32px;\n    color: #666;\n    line-height: 1.6;\n  }\n}\n\n.new-stats-container {\n  display: flex;\n  gap: 20px;\n  margin-top: 30px;\n}\n\n.new-stat-card {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  flex: 1;\n  \n  h3 {\n    font-size: 16px;\n    color: #666;\n    margin-bottom: 12px;\n  }\n  \n  .new-stat-value {\n    font-size: 24px;\n    font-weight: 600;\n    color: #1D283C;\n  }\n}\n\n/* 페이지 제목 스타일은 공통적으로 사용되는 것 같으므로 그대로 사용 */ "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
